import { connect } from 'react-redux';
import View from './LivingExpensesView';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  hasSpouseSelector,
  principalNameSelector,
  spouseNameSelector,
  survivorLivingExpensesOptionsSelector,
  spouseSurvivorLivingExpensesSelector,
  principalSurvivorLivingExpensesSelector,
} from './LivingExpensesSelector';
import { updateWhatIfsData } from '../../WhatIfsActions';
import {
  areOptionsLoaded,
  nullableTitleSelector,
  nullableGroupTitleSelector,
  whatIfTypeSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  whatIfType: whatIfTypeSelector(state, ownProps),
  goalId: selectedGoalId(state, ownProps),
  areOptionsLoaded: areOptionsLoaded(state, ownProps),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  hasSpouse: hasSpouseSelector(state, ownProps),
  principalName: principalNameSelector(state, ownProps),
  spouseName: spouseNameSelector(state, ownProps),
  survivorLivingExpensesOptions: survivorLivingExpensesOptionsSelector(state, ownProps),
  spouseSurvivorLivingExpenses: spouseSurvivorLivingExpensesSelector(state, ownProps),
  principalSurvivorLivingExpenses: principalSurvivorLivingExpensesSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);
